import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

const Input = ({
	className,
	type,
	...props
}: React.ComponentProps<'input'>) => {
	return (
		<input
			data-slot="input"
			type={type}
			className={cn(
				'w-full border-0 border-b border-[var(--line)] bg-transparent px-0 py-2.5 text-base text-[var(--ink)] outline-none transition-colors duration-[180ms] placeholder:text-[var(--muted-2)] focus:border-[var(--ink)] aria-[invalid]:border-[var(--destructive)] disabled:cursor-not-allowed disabled:opacity-50',
				className,
			)}
			style={{ fontFamily: 'var(--font-sans)' }}
			{...props}
		/>
	)
}

export { Input }
